// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"3e55c15e","839":"960019fc"}[chunkId] + ".chunk.js";
};